import React from "react";
import ButtonIcon from "../../../../../../components/buttons/ButtonIcon";
import { CleanIcon } from "../../../../../../components/buttons/IconButtons";
import DivContainerBody from "../../../../../../components/DivContainerBody";
import { WORK_DEPARTMENTS_TABS, WORK_SHIFT_RESOURCE, STEPS_CREATE_WORK_SHIFT } from "../../Model/Models";
import { AddShiftResourceApp } from "../../Functionality/AddShiftResourceApp";
import { AssignedShiftResourceApp } from "../../Functionality/AssignedShiftResourceApp";
import TabPanel from "../../../../../../components/ResourceAssignment/TabPanel";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azapata@ibl.mx
 *
 * Third work shift section: departments Add/Assigned tab panel.
 */
const SectionDepartments = ({
                                id,
                                disabled = false,
                                handleClearStep,
                                departments,
                                setDepartments,
                                selectDeleteDepartments,
                                setSelectDeleteDepartments,
                                searchElement,
                                setSearchElement,
                                modified,
                                setModified
                            }) => {
    return (
            <div className={"row mb-3"}>
                <div className='d-flex justify-content-end col-12 mb-2'>
                    {(id === null || typeof id === 'undefined') &&
                        <ButtonIcon
                            className='btn-clean-secondary-600'
                            id='btn_sd_clean_departments'
                            Icon={CleanIcon}
                            title={'clear_instances'}
                            onClick={() => handleClearStep(STEPS_CREATE_WORK_SHIFT.DEPARTMENTS.INDEX)}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                        />
                    }
                </div>

                <div className={"col-12 mb-4"}>
                    <TabPanel
                        resource={WORK_SHIFT_RESOURCE.DEPARTMENTS}
                        tabsConfig={WORK_DEPARTMENTS_TABS}
                        selected={departments}
                        setSelected={setDepartments}
                        selectForDelete={selectDeleteDepartments}
                        setSelectForDelete={setSelectDeleteDepartments}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        modified={modified}
                        setModified={setModified}
                        id={id}
                        deleteButtonId={'btn_sd_delete'}
                        disabled={disabled}
                        useAddApp={AddShiftResourceApp}
                        useAssignedApp={AssignedShiftResourceApp}
                    />
                </div>
            </div>
    );
}

export default SectionDepartments
